"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFnsStandardDateFormat = exports.standardDateFormat = void 0;
exports.standardDateFormat = "YYYY-MM-DD";
exports.dateFnsStandardDateFormat = "yyyy-MM-dd";
//# sourceMappingURL=standardDateFormat.js.map